import { render, staticRenderFns } from "./PurchaseGoods.vue?vue&type=template&id=5e8de66b&"
import script from "./PurchaseGoods.vue?vue&type=script&lang=js&"
export * from "./PurchaseGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports